import { FirebaseProviderContext } from "./FirebaseProvider.context"
import { useContext } from "react"

export const useFirebaseProvider = () => {
  const context = useContext(FirebaseProviderContext);

  if(context === undefined){
    throw Error("useFirebaseProvider must be used within a FirebaseProvider")
  }

  return context;
}